var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovagrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 431.7 100.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -3888.6848,
    cy: 9.9576,
    r: 96.7198,
    gradientTransform: "matrix(-1 0 0 1 -3865.2793 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429448,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#E9ECD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#D1D7A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    style: {
      stopColor: "#BDC680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3361,
    style: {
      stopColor: "#AEB862"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4113,
    style: {
      stopColor: "#A3AF4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4843,
    style: {
      stopColor: "#9CA940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    style: {
      stopColor: "#9AA73C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M1,50c2,11.1,10,19,17.9,26.8c1.3,1.3,2.8,2.7,4.4,4.1c1.5,1.5,3,2.8,4.5,4 c8.6,7.2,17.2,14.4,28.4,15.3c12.5,1.1,21.5-0.8,27.7-12.4c7-13.2,24.7-70.3,8.7-83C78.5-9.9,23.3,13,10.8,21.2 C-0.2,28.5-1.3,37.6,1,50z M91.9,4.4l0.6,0.5l0.5,0.6c-0.2-0.2-0.4-0.3-0.6-0.5C92.3,4.8,92.1,4.6,91.9,4.4z M17.5,43.6 c6-9,36.3-40,49.9-34.2c14.3,3.9,18.7,47,17.8,57.8c-0.8,9.5-6.3,13.3-15,16.2C62.5,86,54.7,83.6,47,81.3 c-1.3-0.4-2.7-0.9-4.1-1.4c-1.5-0.5-2.8-1-4.1-1.5c-7.5-3-15.1-6-19.6-12.8C14.1,58,12.2,51.6,17.5,43.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -3888.6704,
    cy: 9.9577,
    r: 96.7513,
    gradientTransform: "matrix(-1 0 0 1 -3865.2793 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429448,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#E9ECD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#D1D7A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    style: {
      stopColor: "#BDC680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3361,
    style: {
      stopColor: "#AEB862"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4113,
    style: {
      stopColor: "#A3AF4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4843,
    style: {
      stopColor: "#9CA940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    style: {
      stopColor: "#9AA73C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M68,9.7c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.2-0.5-0.2l0.6,0.2L68,9.7z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: -3912.72,
    cy: 42.4751,
    r: 27.5332,
    gradientTransform: "matrix(-1 0 0 1 -3865.2793 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429448,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06982928,
    style: {
      stopColor: "#F7F7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2073,
    style: {
      stopColor: "#D0D3BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3459,
    style: {
      stopColor: "#AFB48E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    style: {
      stopColor: "#949B67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6179,
    style: {
      stopColor: "#7F8749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7504,
    style: {
      stopColor: "#707934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8791,
    style: {
      stopColor: "#677127"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#646E23"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M69.8,38.8c-3.3-2.9-7.6-3.3-11.9-3.7c-0.7-0.1-1.5-0.1-2.3-0.2c-0.8-0.1-1.6-0.1-2.3-0.1 c-4.3-0.1-8.7-0.2-12.3,2.3c-4,2.7-6.3,5.5-5.3,10.5c1.1,5.7,9.6,27.2,17.6,27.2c7.9,1,18.9-19.3,20.7-24.8 C75.4,45,73.5,42,69.8,38.8z M53.5,74.7l-0.3,0l-0.3,0c0.1,0,0.2,0,0.3,0C53.3,74.7,53.4,74.7,53.5,74.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.4,74.2h-9.5l-18.3-19.7v19.7h-10.5V38.8h9.5l18.3,19.6V38.8h10.6V74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,56.5c0,3.3-0.8,6.3-2.3,9.1c-1.5,2.8-3.8,5-6.8,6.6c-3,1.6-6.7,2.4-11,2.4c-4.4,0-8.1-0.8-11.1-2.5 c-3-1.7-5.3-3.9-6.7-6.7c-1.5-2.8-2.2-5.7-2.2-8.9c0-3.2,0.7-6.1,2.2-8.9c1.5-2.8,3.7-5,6.7-6.7c3-1.7,6.7-2.5,11.1-2.5 c3.3,0,6.2,0.5,8.7,1.5c2.6,1,4.7,2.3,6.3,3.9c1.6,1.7,2.9,3.6,3.7,5.8C201.6,51.7,202,54,202,56.5z M191.1,56.5 c0-1.3-0.2-2.5-0.6-3.6c-0.4-1.1-1-2-1.8-2.9c-0.8-0.8-1.8-1.4-2.9-1.9c-1.1-0.4-2.5-0.7-3.9-0.7c-2.9,0-5.1,0.8-6.7,2.5 c-1.6,1.7-2.4,3.8-2.4,6.5s0.8,4.9,2.5,6.6c1.6,1.7,3.9,2.5,6.7,2.5c2,0,3.6-0.4,5-1.2c1.4-0.8,2.4-1.8,3.1-3.2 C190.8,59.8,191.1,58.2,191.1,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4,38.8l-15.9,35.8h-7l-15.6-35.8h11.1l8.1,20.4l8.3-20.4H242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.2,74.2h-10.9l-2.9-7.2h-15.3l-2.9,7.2h-10.9l15.6-35.3h11.8L282.2,74.2z M266,60.9L260.8,48l-5.2,12.9H266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7720",
    d: "M316.4,44.3c-4.3-2.5-8.3-3.6-12.6-3.6c-9,0-15.7,6.7-15.7,15.7c0,8,5.3,15.7,16.5,15.7 c4.1,0,6.9-0.8,9.8-2.2v-9.6h-7.5V58h10.3v13.6c-4.2,2-8.5,3-12.6,3c-11.1,0-19.4-7.8-19.4-18.4c0-10.4,8.1-18.2,19.1-18.2 c4,0,7.2,0.8,12.2,3V44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7720",
    d: "M333.3,38.6c8.7,0,11.8,4.4,11.8,9.2c0,4.1-2.2,7-6.8,8.7c1.7,0.9,3.1,2.9,4.7,5.4l8,12.3h-3.2l-6.2-9.8 c-4.3-6.7-5.6-7.3-9.9-7.3h-4.8v17.1h-2.8V38.6H333.3z M326.9,54.8h5.9c6.3,0,9.3-2.7,9.3-7c0-4-2.9-6.9-9.4-6.9h-5.8V54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7720",
    d: "M384.5,74.2h-2.9L376,61.8h-17.4L353,74.2h-2.9l16.4-35.9h1.5L384.5,74.2z M367.3,42.8l-7.6,16.8H375 L367.3,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7720",
    d: "M391.6,74.2h-2.8V38.6h2.8V74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7720",
    d: "M431.7,74.2h-2.3l-27-31.1v31.1h-2.8V38.6h2.3l27,31.1V38.6h2.8V74.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovagrain);
export default __webpack_public_path__ + "static/media/novagrain.930188099087f19d73d71ad01d549eb2.svg";
export { ForwardRef as ReactComponent };